import { Box, Button, ContentTemplate, KeyValue, Link, SectionHeader } from 'web-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { Theme as AugmentedTheme } from 'web-library/theme/interface';
import RouteKey from '../../../../routes/key';
import { useGetWithdrawalResult } from '../../../../api/candidate/exam/@coordinator/queries-services/queries';
import { stringToLongDateAndShortTime } from '../../../../utils/DateUtils';
import { useWOGAA } from '../../../../hooks/wogaa';

const { withdrawal } = RouteKey.child;
const { summary, withdrawal: withdrawalRoute } = RouteKey.withdrawal.child;

const useStyles = makeStyles()((theme) =>
({
  viewSummaryText: {
    fontWeight: 800,
    paddingLeft: theme.spacing(1),
  },
}));

const Submitted = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const { uuid } = useParams<{ uuid: string }>();

  const { data: withdrawalResult } = useGetWithdrawalResult(uuid);

  // wogaa tracking for coordinator exam registration for end withdrawal //
  const { transactionEnd } = useWOGAA('myexamsseab-6456');
  transactionEnd(uuid);

  const handleViewFullSummaryClick = () => {
    history.push(`/${withdrawal}/${withdrawalRoute.route}/${uuid}/${summary.route}`);
  };

  const handleViewRegisteredExamClick = () => {
    history.push(`/${withdrawal}/${withdrawalRoute.route}`);
  };

  return (
    <ContentTemplate>
      <SectionHeader
        title={t('withdrawal->>Coordinator.Summary.Submit.SectionHeader')}
      >
        <Link
            id="link-viewFullSummary"
            className={classes.viewSummaryText}
            onClick={handleViewFullSummaryClick}
        >
          {t('withdrawal->>Coordinator.Summary.Submit.ViewFullSummary')}
        </Link>
      </SectionHeader>
      <Box marginBottom={theme.spacing(0.2)}>
        <KeyValue
          id="applicationId"
          keyText={t('withdrawal->>Coordinator.Summary.Content.ApplicationID')}
          valueText={withdrawalResult?.applicationId}
        />
        <KeyValue
          id="applicationId"
          keyText={t('withdrawal->>Coordinator.Summary.Content.ApplicationDateTime')}
          valueText={stringToLongDateAndShortTime(withdrawalResult?.localDateTime || '')}
        />
      </Box>
      <Box marginBottom={theme.spacing(2)}>
        <Button id="viewRegisteredExams" onClick={handleViewRegisteredExamClick}>
          {t('withdrawal->>Coordinator.Summary.Submit.ViewWithdrawalApplications')}
        </Button>
      </Box>
    </ContentTemplate>
  );
};

export default Submitted;
